// Home page specific scripts
import './layout.js';
import { trackEvent } from './analytics.js';
import { initSyllabusDemo } from './syllabus-demo.js';

document.addEventListener('DOMContentLoaded', function() {
    console.log('MBA Lab - Home page initialized');

    // Funnel: landing viewed (home bundle only loads on Index)
    trackEvent('landing_viewed', { page_type: 'landing' });

    // The hero's live try-the-parser window.
    initSyllabusDemo();

    // CTA: Get started clicks. Bound on data-get-started (the attribute carries the placement),
    // never on href: the old selector matched the ComingSoon-era destination, and when the CTAs
    // moved to real sign-in this event silently stopped firing - same failure mode layout.js's
    // data-cta delegation exists to avoid.
    document.querySelectorAll('[data-get-started]').forEach(function(el) {
        el.addEventListener('click', function() {
            trackEvent('get_started_clicked', { cta_placement: el.getAttribute('data-get-started') || 'body' });
        });
    });

    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            if (href !== '#' && href.length > 1) {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    });
});

